import React, { createContext, useContext } from 'react';

import type { FormInstance } from 'antd';

import type { DataQuarterFilterFormValues, QuarterOption } from './types';

type DataQuarterFilterContextValue = {
  quarters: QuarterOption[];
  form: FormInstance<DataQuarterFilterFormValues>;
  reset: () => void;
};

export const DataQuarterFilterContext = createContext<DataQuarterFilterContextValue>({
  quarters: [],
  form: {} as FormInstance<DataQuarterFilterFormValues>,
  reset: () => {
    // Do nothing
  },
});

export const useDataQuarterFilterContext = () => useContext(DataQuarterFilterContext);
